"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Preview_1 = __importDefault(require("./editor/Preview"));
const share_1 = require("../data/share");
class EmbedPreview extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            shareLink: null
        };
    }
    render() {
        return (React.createElement("div", { className: "embed-preview" },
            React.createElement(Preview_1.default, { project: this.props.project, asExample: true, iterationLimit: 8, yOffset: this.props.yOffset }),
            React.createElement("a", { href: this.state.shareLink ||
                    "https://codesculpture.amimetic.co.uk/editor", target: "_blank", className: "example-edit-button" }, "Edit")));
    }
    componentDidMount() {
        this.setState({
            shareLink: share_1.generateUrl(this.props.project, "https://codesculpture.amimetic.co.uk/editor", "rules")
        });
    }
}
exports.default = EmbedPreview;



// WEBPACK FOOTER //
// ./src/components/EmbedPreview.tsx